<template>
  <v-system-bar app fixed height="50" style="font-family: Arial;" color="#157bc6">
    <div class="bigd-container" style="width: 100%;">
      <nav class="bigd-navbar-default bigd-navbar">
        <div class="bigd-container-fluid">
          <div class="bigd-navbar-header" style="margin-left: 10px;">
            <button type="button" class="bigd-navbar-toggle bigd-collapsed" @click="toggleNavbar">
              <span class="bigd-sr-only">Toggle navigation</span>
              <span class="bigd-icon-bar"></span>
              <span class="bigd-icon-bar"></span>
              <span class="bigd-icon-bar"></span>
            </button>
            <a href="https://www.cncb.ac.cn" target="_blank" class="bigd-navbar-brand">
              <img :src="logoUrl" class="bigd-img-responsive" />
            </a>
            <a href="https://ngdc.cncb.ac.cn/" target="_blank" class="bigd-navbar-brand" style="margin-top: 2px;">
              <img :src="ngdcLogoUrl" class="bigd-img-responsive" />
            </a>
          </div>
          <div class="bigd-collapse bigd-navbar-collapse" :style="{ display: navbarDisplay }" id="bigd-coll">
            <ul class="bigd-nav bigd-navbar-nav bigd-navbar-right">
              <li><a href="https://www.cncb.ac.cn/services" target="_blank"><strong>Data Resources</strong></a></li>
              <li><a href="https://www.cncb.ac.cn/tools" target="_blank"><strong>Computing Analysis</strong></a></li>
              <li><a href="https://www.cncb.ac.cn/nodes" target="_blank"><strong>Data Network</strong></a></li>
              <li><a href="https://www.cncb.ac.cn/standards" target="_blank"><strong>Standards</strong></a></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </v-system-bar>
</template>

<script>
export default {
  name: 'HeaderBar',
  data() {
    return {
      logoUrl: "https://ngdc.cncb.ac.cn/static/image/cncb-logo-w.png",
      // ngdcLogoUrl: "https://ngdc.cncb.ac.cn/static/image/ngdc.png",
      ngdcLogoUrl: "https://ngdc.cncb.ac.cn/static/image/ngdc-logo-blue.png",
      navbarDisplay: "none"
    };
  },
  methods: {
    toggleNavbar() {
      this.navbarDisplay = this.navbarDisplay === "none" ? "block" : "none";
    }
  }
};
</script>

<style scoped>
@import url('../../sass/page.min.css');
</style>
